import { Injectable } from '@angular/core'
import { TmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { IClaimLineAction } from './claimLineAction'
import { ODataService } from 'common-services'

export interface IClaimLineView extends IModelBase {
  ClaimId: number
  ServiceId: number
  FileId: number
  FileKey: string
  Identifier: string
  ServiceLineId: number
  ProviderName: string
  BillingProviderNpi: number
  PlanName: string
  PatientId: string
  PatientName: string
  SubscriberId: string
  SubscriberName: string
  PatientEpisodeId: number
  AuthorizationNumber: string
  Units: number
  Modifiers: string
  DateOfService: string
  ProcedureCode: string
  Phase: string
  DiagnosisCodes: string
  ClaimType: string
  DaysSinceReceived: number
  ProcessingType: string
  ValidationStatus: string
  DaysInStatus: number
  StatusId: number
  Status: string
  AvailableActions: IClaimLineAction[]
  BilledAmount: number
  RevenueCode: string
  StatementDate: string
  LineOfBusiness: string
  FrequencyTypeCode: string
  FrequencyTypeDescription: string
  AdjudicationType: string
  AutoAdjudicated?: boolean
}

@Injectable()
export class ClaimLineViewODataService extends ODataService<IClaimLineView> {
  constructor(protected http: HttpClient, protected config: TmODataConfiguration) {
    super(http, config)
    this.typeName = 'ClaimsView'
  }
}
